export function projectPopupSlider() {
    let $slider = $('.project-popup-slider');
    $slider.slick({
        speed: 700,
        cssEase: 'ease-out',
        dots: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/projectPopupSlider.js